import { FC } from "react";

import Image, { IImage } from "apps/website/components/base/Image/Image";
import Text from "apps/website/components/base/Text/Text";
import {
  legacySizeCollectionMap,
} from "apps/website/components/base/Text/Text.map";
import { renderTableValue } from "apps/website/utils/content/table";
import Table from "apps/website/components/feature/Table/Table";
import {
  cellStyles,
  rowAltStyles,
  rowStyles,
  tableStyles,
  titleStyles,
  valueStyles,
} from "apps/website/components/feature/Table/Table.map";
import cx from "apps/website/utils/misc/cx";
import TextBody from "apps/website/components/base/Text/TextBody/TextBody";
import TextControl from "apps/website/components/base/Text/TextControl/TextControl";
// TODO: move ITableTitle
export interface ITableTitle {
  id: string;
  name: string;
  image?: IImage;
  subheading?:string;
}

export interface IColumnRowTableRow {
  title: string;
  values: (boolean | string)[];
}

export interface IColumnRowTable {
  component?: string,
  columnTitles: ITableTitle[];
  rows: IColumnRowTableRow[];
  highlightColumn?: number;
  className?: string;
  footer?: React.ReactNode;
}

const ColumnRowTable: FC<IColumnRowTable> = ({ columnTitles, rows, component = "ColumnRowTable", highlightColumn, className, footer }) => (
  <>
    <Table component={component} className={cx(tableStyles, className)}>
      <tr className={rowStyles}>
        <td></td>
        { columnTitles.map((title, index) => (
          <th
            key={title.id}
            scope="col"
            className={`${titleStyles} ${index > 2 && "hidden lg:table-cell"} ${highlightColumn === index && "relative bg-white border-x-4 border-solid border-black"}`}
          >
            { title.subheading ? (
              <div className="flex flex-col items-center text-center px-2 min-h-[120px]">
                <div className="h-[40px] flex items-center justify-center">
                  { title.image ? (
                    <>
                      <Image image={title.image.image} alt={title.image.alt} />
                      <span className="sr-only">{ title.name }</span>
                    </>
                  ) : (
                    <Text tag="span" display="subtitle" size={legacySizeCollectionMap.titleSm} align={"center"}>
                      { title.name }
                    </Text>
                  ) }
                </div>

                <TextControl
                  size={4}
                  align="center"
                  whitespace="normal"
                  className="mt-2 max-w-[140px] grow"
                >
                  { title.subheading }
                </TextControl>
              </div>
            ) : (
              <>
                { title.image ? (
                  <>
                    <Image image={title.image.image} alt={title.image.alt} />
                    <span className="sr-only">{ title.name }</span>
                  </>
                ) : (
                  <Text tag="span" display="subtitle" size={legacySizeCollectionMap.titleSm}>
                    { title.name }
                  </Text>
                ) }
              </>
            ) }

            { highlightColumn === index && (
              <>
                <div className="bg-white absolute w-[calc(100%+8px)] h-[20px] -top-[18px] -left-[4px] border-x-4 border-t-4 border-black border-solid" />
                <div className="bg-white absolute w-full h-[3px] -bottom-[2px] left-0" />
              </>
            ) }
          </th>

        )) }
      </tr>

      { rows.map((row, rowIndex) => (
        <tr key={row.title} className={`${rowStyles} ${rowIndex % 2 === 0 && rowAltStyles}`}>
          <th scope="row" className={`text-left ${cellStyles}`}>
            <Text tag="span" display="subtitle" size={legacySizeCollectionMap.titleSm}>
              { row.title }
            </Text>
          </th>
          { row.values.map((value, valueIndex) => (
            <td key={`value-${rowIndex}-${valueIndex}`} className={`${valueStyles} ${cellStyles} ${valueIndex > 2 && "hidden lg:table-cell"} ${highlightColumn === valueIndex && "relative bg-white border-x-4 border-solid border-black"}`}>
              { renderTableValue(value, highlightColumn === valueIndex) }
              { highlightColumn === valueIndex && (
                <>
                  <div className="bg-white absolute w-full h-[3px] -bottom-[2px] left-0" />
                  { rowIndex + 1 === rows.length && (
                    <div className="bg-white absolute w-[calc(100%+8px)] h-[20px] -bottom-[18px] -left-[4px] border-x-4 border-b-4 border-black border-solid" />
                  ) }
                </>
              ) }
            </td>
          )) }
        </tr>
      )) }
    </Table>
    { footer && (
      <div className="flex justify-center items-center mt-4 mx-auto">
        <TextBody size={4} align="center" whitespace="normal">
          <span className="[&>p]:my-0 flex flex-col gap-y-2" dangerouslySetInnerHTML={{ __html: footer }} />
        </TextBody>
      </div>
    ) }
  </>
);

export default ColumnRowTable;
